export default __webpack_public_path__ + "static/media/soesvinget.701f6d88.mp4";